import React from 'react';
import { Check, Info, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Dialog component
const Dialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full">
        {children}
      </div>
    </div>
  );
};

// DialogContent component
const DialogContent = ({ children, className = "", onClose }) => {
  return (
    <div className={`p-4 sm:p-6 ${className} relative`}>
      {children}
      <button 
        onClick={onClose}
        className="absolute top-2 right-2 p-2 rounded-full hover:bg-gray-100 transition-colors"
      >
        <X className="h-5 w-5 text-black" />
      </button>
    </div>
  );
};

// DialogHeader component
const DialogHeader = ({ children }) => {
  return (
    <div className="mb-4">
      {children}
    </div>
  );
};

// DialogTitle component
const DialogTitle = ({ children }) => {
  return (
    <h2 className="text-lg font-semibold text-black">
      {children}
    </h2>
  );
};

const Pricing = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = React.useState(false);

  const handleSubscribeClick = () => {
    // Logic for subscription (you can replace with actual subscription logic)
    window.location.href = 'https://app.futeur.ai/signup';
  };

  const handleSeeHowItWorksClick = () => {
    navigate('/SeeHowItWorks');
  };

  const handleSeeSamplesClick = () => { 
    navigate('/SeeSample');
  }

  return (
    <>
      <Dialog open={showModal} onOpenChange={setShowModal}>
        <DialogContent onClose={() => setShowModal(false)}>
          <DialogHeader>
            <DialogTitle>Exclusive Early Access</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 text-black">
            <p>Be among the first 500,000 businesses to gain executive-level access to upcoming FuteurAI innovations, including:</p>
            <ul className="space-y-2 pl-6">
              <li className="list-disc">
                <span className="font-semibold">Futeur Intelligence:</span> Advanced AI tools tailored to your business needs.
              </li>
              <li className="list-disc">
                <span className="font-semibold">Digital Banking Products:</span> Access to our suite of digital banking solutions designed for seamless financial management.
              </li>
            </ul>
          </div>
        </DialogContent>
      </Dialog>

      <div className="relative py-12 sm:py-20 md:py-32 px-4 bg-[#ffffff]">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-center mb-4 text-black">
            One Simple Plan. Infinite Potential.
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-center mb-8 sm:mb-12 text-black">
            We don't trap you with complex pricing or long-term commitments. Just one
            straightforward monthly plan that lets our AI-powered insights do the
            talking.<br/> You'll see the value every step
            of the way—because empowering your business is what we do best.
          </p>

          <div className="bg-white rounded-xl shadow-lg relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-[#31a2ff] text-black py-1 px-4 text-xs sm:text-sm font-semibold">
              BEST VALUE FOR YOUR BUSINESS
            </div>

            <div className="p-4 sm:p-6 md:p-8">
              <div className="flex flex-col sm:flex-row justify-between items-start mb-6 sm:mb-8 mt-6 sm:mt-8 ">
                <div>
                  <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 text-black">Infinity Access Plan</h2>
                  <p className="text-sm sm:text-base text-black font-semibold mb-2">Transparent. Intuitive. Revolutionary.</p>
                  <p className="text-sm sm:text-base text-black">Leveling the Playing Field- Empowering 34.8 Million Small Business with AI-Driven Growth and Equality</p>
                </div>
                <div className="text-left sm:text-right text-black mt-4 sm:mt-0">
                  <p className="text-2xl sm:text-3xl font-bold">$32/month</p>
                  <p className="text-xs sm:text-sm text-gray-600">billed monthly</p>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4 mb-6 sm:mb-8">
                <div>
                  <h6 className="font-semibold mb-2 text-black">Distinctive Features That Set Us Apart</h6>
                  <ul className="space-y-2 text-black">
                    <Feature text="Full PDF Credit Reports" />
                    <Feature text="Reports from Multiple Bureaus" />
                    <Feature text="Real-Time Credit Monitoring" />
                    <Feature text="Tradeline Reporting" />
                    <ul className="space-y-2 text-black">
                    <Feature text="Dispute Resolution Services" />
                    <li className="flex items-center">
                      <Check className="text-green-500 mr-2 flex-shrink-0" />
                      <span>Exclusive Early Access</span>
                      <button 
                        onClick={() => setShowModal(true)}
                        className="ml-2 p-1 hover:bg-gray-100 rounded-full transition-colors"
                      >
                        <Info className="h-4 w-4 text-gray-500" />
                      </button>
                    </li>
                  </ul>
                  </ul>
                </div>
               
              </div>
            </div>

            <div className="bg-[#1111] p-4 sm:p-6 md:p-8 text-center">
              <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                <button
                  className="bg-[#1b2b32] text-white px-6 py-3 text-base sm:text-lg font-semibold hover:bg-[#2c3e50] transition-colors w-full sm:w-auto rounded-sm"
                  onClick={handleSubscribeClick}
                >
                  Subscribe Now
                </button>
                <button
                className="bg-[#1b2b32] text-white px-6 py-3 text-base sm:text-lg font-semibold hover:bg-[#2c3e50] transition-colors w-full sm:w-auto rounded-sm"
                onClick={handleSeeSamplesClick}
              >
                See Samples
              </button>
                <button
                  className="bg-[#1b2b32] text-white px-6 py-3 text-base sm:text-lg font-semibold hover:bg-[#2c3e50] transition-colors w-full sm:w-auto rounded-sm"
                  onClick={handleSeeHowItWorksClick}
                >
                  See How It Works
                </button>
              
              </div>

              <p className="mt-4 text-xs sm:text-sm text-gray-600">
                Experience unparalleled support and innovation with FuteurAI's Infinity Access plan - 
                your gateway to infinite growth and success.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Feature = ({ text }) => (
  <li className="flex items-center">
    <Check className="text-green-500 mr-2 flex-shrink-0" />
    <span>{text}</span>
  </li>
);

export default Pricing;

